import { z } from 'zod';

import { ZodSuccessResponse } from '@Common/types/response';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';

export const ZodMicaSfaAgreementStatus = z.enum(['approved', 'denied']);
export type MicaSfaAgreementStatus = z.infer<typeof ZodMicaSfaAgreementStatus>;

const ZodPutQuestionsLegalAgreementsBody = z.object({
  sda_agreement_at: z.string().datetime().nullable().optional(),
  stocks_trading_agreement_at: z.string().datetime().nullable().optional(),
  mica_sfa_agreement_status: ZodMicaSfaAgreementStatus.optional(),
});
export type PutQuestionsLegalAgreementsBody = z.TypeOf<typeof ZodPutQuestionsLegalAgreementsBody>;

export const putQuestionsLegalAgreementsEndpoint = endpoint({
  method: 'PUT',
  body: ZodPutQuestionsLegalAgreementsBody,
  responseBody: ZodSuccessResponse,
});

export type PutQuestionsLegalAgreementsEndpoint = GetEndpointType<
  typeof putQuestionsLegalAgreementsEndpoint
>;
